export default __webpack_public_path__ + "static/media/dados_basicos.02cb916f.svg";